/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import {AbstractSearchCriteriaService} from '../../shared/filter/abstract-search-criteria.service';
import {SettlementColumnEnum} from '../models/settlement-column.enum';
import {SettlementQueryContract} from '../api/contracts/settlement-query.contract';
import {SettlementSearchCriteriaContract} from '../api/contracts/settlement-search-criteria.contract';
import {SortDirection} from '../../api/generic/contracts/sort-direction.enum';

@Injectable({
    providedIn: 'root'
})

export class SettlementSearchCriteriaService extends AbstractSearchCriteriaService<SettlementColumnEnum> {
    clear(): void {
        // clear stored filters
        this.stateMap.clear();

        // Sort criteria
        this.sortDirection = SortDirection.DESC;
        this.sortedBy = SettlementColumnEnum.LAST_CHANGE_DATETIME;

        // Pagination
        this.pageSize = 20;
        this.pageNumber = 1;
        this.totalResults = 0;
    }

    public getSettlementsQuery(hasPaginationCriteria?: boolean): SettlementQueryContract {
        const searchCriteria: SettlementSearchCriteriaContract = {
            customerCodes: this.mapCodeCriterion(SettlementColumnEnum.CUSTOMER),
            supplierCodes: this.mapCodeCriterion(SettlementColumnEnum.SUPPLIER),
            statusCodes: this.mapCodeCriterion(SettlementColumnEnum.STATUS),
            complaintCode: this.mapStringCriterion(SettlementColumnEnum.COMPLAINT_CODE),
            settlementCode: this.mapStringCriterion(SettlementColumnEnum.SETTLEMENT_CODE),
            lastPendingDate: this.mapDateCriterion(SettlementColumnEnum.LAST_PENDING_DATE),
            lastChangeDatetime: this.mapDateCriterion(SettlementColumnEnum.LAST_CHANGE_DATETIME),
            materialsTotalGrossCost: this.mapDecimalQuantityCriterion(SettlementColumnEnum.MATERIALS_TOTAL_GROSS_COST),
            teMinutesTotalCost: this.mapDecimalQuantityCriterion(SettlementColumnEnum.TE_MINUTES_TOTAL_COST),
            settlementTotalCost: this.mapDecimalQuantityCriterion(SettlementColumnEnum.SETTLEMENT_TOTAL_COST)
        };

        return {
            searchCriteria,
            paginationCriteria: hasPaginationCriteria ? this.paginationCriteria : this.resetPaginationCriteria
        };
    }
}
